// extracted by mini-css-extract-plugin
export var lightMode = "_k-0";